const ONGOING_WORKOUT_STATUSES = new Set(['ongoing', 'in_progress', 'started']);

export const isOngoingWorkoutActivity = (activity, now = Date.now()) => {
  if (!activity || activity.type !== 'workout') return false;
  if (!ONGOING_WORKOUT_STATUSES.has(activity.status)) return false;
  if (!activity.due_at) return true;
  return new Date(activity.due_at).getTime() >= now;
};

export { ONGOING_WORKOUT_STATUSES };
